import { render, staticRenderFns } from "./Ophthalmology.vue?vue&type=template&id=518d96c9&scoped=true"
import script from "./Ophthalmology.vue?vue&type=script&lang=js"
export * from "./Ophthalmology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d96c9",
  null
  
)

export default component.exports